export default __webpack_public_path__ + "static/image/image009.143a7e85.jpg";